// groupMembers.js

import store from '../../admin/store'
import { mapGroupHeaderPropsToObject } from '../components/groups/helpers'

// Actions
export const DELETE_MEMBER = 'DELETE_MEMBER'
export const ACTIVATE_MEMBER = 'ACTIVATE_MEMBER'

// Reducer
const initialState = {}

export const reducer = (state = initialState, action) => {
    switch(action.type) {
        case ACTIVATE_MEMBER: {
            return {
                ...state,
                [action.id]: {
                    ...state[action.id],
                    deleted_at: null,
                },
            }
        }
        case DELETE_MEMBER: {
            return {
                ...state,
                [action.id]: {
                    ...state[action.id],
                    deleted_at: new Date(),
                },
            }
        }
        default:
            return state
    }
}

// Action Creators
export const toggleBusy = () => ({
    type: 'TOGGLE_BUSY_SECTION',
    section: 'admin.groups.members',
})

/** @TODO - need refactor logic for call become member only if is it actually */
const successBecomeMember = () => {
    setTimeout(() => {
        const becomeMemberButton = document.getElementById('group-become-member')
        if (becomeMemberButton) {
            becomeMemberButton.click()
        }
    }, 1000)
}

const checkAuthedUser = state => {
    if (!state.auth.user) {
        store.dispatch({
            type: 'SET_LOGIN_MODAL',
            text: 'Pro tuto akci musíte být přihlášení v aplikaci.',
            successAction: successBecomeMember,
        })

        return false
    }

    return true
}

// Thunks
export const activateMember = (slug, member) => {
    store.dispatch(toggleBusy())

    return window.axios.patch(
        `${window.APP_CONFIG.REACT_APP_API_URL}api/groups/${slug}/members/${member.id}`,
        {
            ...member,
            deleted_at: null,
        }
    ).then(() => {
        store.dispatch({
            type: ACTIVATE_MEMBER,
            id: member.id,
        })
        store.dispatch(toggleBusy())
    }).catch(() => store.dispatch(toggleBusy()))
}

export const removeMember = (slug, id) => {
    store.dispatch(toggleBusy())

    return window.axios.delete(`${window.APP_CONFIG.REACT_APP_API_URL}api/groups/${slug}/members/${id}`)
        .catch(() => store.dispatch(toggleBusy()))
}

export const updateConnectedAccount = (group, membership, userId) => {
    store.dispatch({
        type: 'TOGGLE_BUSY_SECTION',
        section: 'front.group.members',
        force: true,
    })

    return window.axios.put(
        `${window.APP_CONFIG.REACT_APP_API_URL}api/groups/${group.slug}/members/${membership.id}/connected-account`,{
            id: membership.id,
            user_id: userId,
        }
    )
        .then(() => store.dispatch({
            type: 'TOGGLE_BUSY_SECTION',
            section: 'front.group.members',
            force: false,
        }))
        .catch(() => {
            // TODO reload below is hotfix of https://astrumq.atlassian.net/browse/SPORTNECT-2689
            window.location.reload()
            store.dispatch({
                type: 'TOGGLE_BUSY_SECTION',
                section: 'front.group.members',
                force: false,
            })
        })
}

export const resolveMembershipRequest = (group, data) => {
    store.dispatch(toggleBusy())

    return window.axios.post(`${window.APP_CONFIG.REACT_APP_API_URL}api/groups/${group.slug}/resolved-membership-requests`, data)
        .then(() => {
            store.dispatch(toggleBusy())

            /** @TODO properly add proposed user to store then remove this */
            window.location.reload()
        }).catch(() => store.dispatch(toggleBusy()))
}

export const becomeMember = group => {
    if (!checkAuthedUser(store.getState())) {
        return new Promise(resolve => resolve())
    }

    const authedUser = store.getState().auth.user

    const property = mapGroupHeaderPropsToObject(authedUser, group)

    if (property.canBecomeMember && !property.myMembership && !property.myMembershipRequest) {
        store.dispatch({
            type: 'TOGGLE_BUSY_SECTION',
            section: 'front.group.members',
            force: true,
        })

        return window.axios.post(`${window.APP_CONFIG.REACT_APP_API_URL}api/groups/${group.slug}/members`, {
            name: authedUser.name,
            surname: authedUser.surname,
            user_id: authedUser.id,
        }).then(() => {
            store.dispatch({
                type: 'TOGGLE_BUSY_SECTION',
                section: 'front.group.members',
                force: false,
            })
        }).catch(() => {
            store.dispatch({
                type: 'TOGGLE_BUSY_SECTION',
                section: 'front.group.members',
                force: false,
            })
        })
    }

    return new Promise(resolve => resolve())
}
